import React from "react";
import TableRow from "./table-row";
import { TableColumn } from "./constants";

interface TableBodyProps {
  data: any[];
  columns: TableColumn[];
  actions?: (row: any) => React.ReactNode;
}

// Memoized body component
const TableBody: React.FC<TableBodyProps> = React.memo(
  ({ data, columns, actions }) => {
    return (
      <tbody className="bg-white divide-y divide-gray-200">
        {data.map((row, rowIndex) => (
          <TableRow
            key={row.id || rowIndex} // Use row.id if available, fallback to index
            row={row}
            columns={columns.filter((column) => column.show !== false)}
            rowIndex={rowIndex}
            actions={actions}
          />
        ))}
      </tbody>
    );
  }
);

TableBody.displayName = "TableBody";

export default TableBody;
